import { createStyles, makeStyles, Theme, focusStyle } from 'ui-components';
import { fontText } from 'common-react';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiPaper-root': {
      [theme.breakpoints.down('sm')]: {
        top: 'auto',
      }
    },
    '& .MuiDialog-paper': {
      maxWidth: '100%',
    },
  },
  contentWrapper: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: 16,
    },
  },
  productWizardTransLink: {
    display: 'block',
    '&:focus-visible': {
      ...focusStyle(theme)
    }
  },
  dialogContent: {
    backgroundColor: theme.color.greys[0],
    borderRadius: 8,
    margin: '10px 20px',
    padding: '30px 70px',
    width: '80vw',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 8,
      padding: '20px 16px',
    },
    '& .MuiTypography-body1': {
      [theme.breakpoints.down('sm')]: {
        font: fontText('normal', theme.fontSize.s, 18),
      },
    },
  },
  chooseButton: {
    marginBottom: 15,

    '& .MuiButton-label a': {
      border: 'none',
      backgroundColor: 'transparent',
    }
  },
  ikeIkzeKorpoLabel: {
    marginTop: 30,
    display: 'block',
    font: fontText('normal', theme.fontSize.base, 20),
  },
}), { name: 'IkeOrIkzeMobileChooseDialog' });
